import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import Dropdown from '../../components/inputFields/DropDown';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import SearchBar from '../../components/searchBar/SearchBar';
import { getProductStats, getProducts, patchProductDetails } from '../../services/products';
import { toast } from 'react-toastify';
import { BiCopy, BiRefresh } from 'react-icons/bi';
import GalleryComponent from '../../components/GalleryComponent';
import { Link } from 'react-router-dom';
import { GoEye } from 'react-icons/go';
import { Link2Icon } from 'lucide-react';
import { getManufacturers } from '../../services/manufacturer';


function Products() {
    const [cardData, setCardData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentSort, setCurrentSort] = useState(null);
    const [currentSortDir, setCurrentSortDir] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [brands, setBrands] = useState([]);
    const headers = [
        { label: "Image", key: "image" },
        { label: "Name", key: "name", needFilter: true },
        { label: "Order", key: "order", needFilter: true },
        // { label: "Category", key: "category" },
        { label: "Discount", key: "discount_percentage", needFilter: true },
        { label: "Today's Of.", key: "is_today_offer" },
        // { label: "Top Offer", key: "top_offer" },
        // { label: "Manufacture", key: "manufacture" },
        { label: "MRP", key: "mrp" },
        { label: "Price", key: "price", needFilter: true },
        { label: "Stock", key: "available_stock", needFilter: true },
        { label: "Sold (Life)", key: "sold_stock" },
        // { label: "Shop", key: "shop" },
        { label: "Availability", key: "availability_status" },
        { label: "Website", key: "website_url" },
    ];

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleBrandChange = (value) => {
        setFilterBrand(value);
        fetchData(buildQuery({ brand: value }));
    };

    const handleAvailabilityChange = (value) => {
        setFilterAvailability(value);
        fetchData(buildQuery({ availability: value }));
    };

    const [searchText, setSearchText] = useState("");
    const [filterBrand, setFilterBrand] = useState("");
    const [filterAvailability, setFilterAvailability] = useState("");
    const [filterTopOffer, setFilterTopOffer] = useState(""); // "", true, false
    const [filterTodayOffer, setFilterTodayOffer] = useState(""); // "", true, false

    const pageSize = 10;

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(buildQuery({ search: query }));
    };

    const sortKeyMap = {
        name: 'product_name',
        price: 'price',
        order: 'order',
        discount_percentage: 'discount_percentage',
        available_stock: 'available_stock',
    };

    const buildQuery = (overrides = {}) => {
        const q = [];
        const s = overrides.search !== undefined ? overrides.search : searchText;
        const avail = overrides.availability !== undefined ? overrides.availability : filterAvailability;
        const top = overrides.top_offer !== undefined ? overrides.top_offer : filterTopOffer;
        const today = overrides.is_today_offer !== undefined ? overrides.is_today_offer : filterTodayOffer;
        const brand = overrides.brand !== undefined ? overrides.brand : filterBrand;
        const sortKey = overrides.sortKey !== undefined ? overrides.sortKey : currentSort;
        const sortDir = overrides.sortDir !== undefined ? overrides.sortDir : currentSortDir;

        if (s && s.length > 0) q.push(`search=${encodeURIComponent(s)}`);
        if (avail && avail.length > 0) q.push(`availability_status=${encodeURIComponent(avail)}`);
        if (top !== "") q.push(`top_offer=${top}`);
        if (today !== "") q.push(`is_today_offer=${today}`);
        if (brand !== "") q.push(`manufacturer=${encodeURIComponent(brand)}`);

        if (sortKey && sortDir) {
            const backendKey = sortKeyMap[sortKey] || sortKey;
            const ordering = `${sortDir === 'desc' ? '-' : ''}${backendKey}`;
            q.push(`sort_by=${encodeURIComponent(ordering)}&order=${sortDir}`);
        }

        return q.length ? `?${q.join('&')}` : '';
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getProducts(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error in Manufacturers:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchStats = async () => {
        try {
            let res = await getProductStats();
            if (res.status === 200) {
                const data = res.data;
                setCardData(data);
            } else {
                toast.error("Unable to fetch stats");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error in Manufacturers:", error);
        }
    };

    const resetFilters = () => {
        setSearchText("");
        setFilterAvailability("");
        setFilterBrand("");
        setFilterTopOffer("");
        setFilterTodayOffer("");
        setFilterBrand("");
        setCurrentSort(null);
        setCurrentSortDir(null);
        fetchData("");
    };

    useEffect(() => {
        fetchData("");
        fetchStats();
        getBrands();
    }, []);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch(() => {
                toast.error('Failed to copy address');
            });
    };

    const handleTableSort = ({ key, filter }) => {
        // filter: 'asc' | 'desc' | 'none'
        if (!key) {
            setCurrentSort(null);
            setCurrentSortDir(null);
            fetchData(buildQuery({ sortKey: null, sortDir: null }));
            return;
        }
        const newDir = filter === 'none' ? null : filter;
        setCurrentSort(key);
        setCurrentSortDir(newDir);
        fetchData(buildQuery({ sortKey: key, sortDir: newDir }));
    };

    const handleOrderChange = async (it, newStatus) => {
        try {
            let res = await patchProductDetails({
                id: it.id,
                data: {
                    order: newStatus,
                },
            });
            if (res.status === 200) {
                toast.success("Order Updated");
                data.results.map((item, index) => {
                    if (item.id === it.id) {
                        item.order = newStatus;
                    }
                });
                setData({ ...data });
            } else {
                toast.error("Unable to update Order");
            }
        } catch (error) {
            console.error("Error in updating details:", error);
        }
    };

    const handleStockChange = async (it, newStatus) => {
        try {
            let res = await patchProductDetails({
                id: it.id,
                data: {
                    availability_status: newStatus,
                },
            });
            if (res.status === 200) {
                toast.success("Stock Updated");
                data.results.map((item, index) => {
                    if (item.id === it.id) {
                        item.availability_status = newStatus;
                    }
                });
                setData({ ...data });
            } else {
                toast.error("Unable to update Stock");
            }
        } catch (error) {
            console.error("Error in updating details:", error);
        }
    };

    const handleIsTodayOffer = async (it, value) => {
        try {
            let res = await patchProductDetails({
                id: it.id,
                data: {
                    is_today_offer: value,
                },
            });
            if (res.status === 200) {
                toast.success("Updated Today's Offer");
                data.results.map((item, index) => {
                    if (item.id === it.id) {
                        item.is_today_offer = value;
                    }
                });
                setData({ ...data });
            } else {
                toast.error("Unable to update Offer");
            }
        } catch (error) {
            console.error("Error Updating Popup:", error);
        }
    };

    const handleTopOffer = async (it, value) => {
        try {
            let res = await patchProductDetails({
                id: it.id,
                data: {
                    order: value ? 0 : 1,
                },
            });
            if (res.status === 200) {
                toast.success("Updated Top Offer");
                data.results.map((item, index) => {
                    if (item.id === it.id) {
                        item.order = value ? 0 : 1;
                    }
                });
                setData({ ...data });
            } else {
                toast.error("Unable to update Top Offer");
            }
        } catch (error) {
            console.error("Error Updating Top Offer:", error);
        }
    };

    const getBrands = async () => {
        let res = await getManufacturers("");
        if (res.status === 200) {
            setBrands(res.data.results.map((item) => ({ value: item.id, label: item.name })));
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Bazaar', },
            { name: 'Products' },
        ]} />
        <div className="py-3">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <StyledHeadingText text={"Products"} />
                <Link
                    to="/bazzar/products/add"
                    className="inline-flex items-center justify-center rounded-lg bg-primary text-white text-sm font-semibold px-4 py-2.5 hover:opacity-90 transition-opacity shadow-sm"
                >
                    + Add product
                </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.value} />
                ))}
            </div>
        </div>
        {/* Search and Filters Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="flex flex-col lg:flex-row gap-4">
                {/* Search Bar Section */}
                <div className="flex-1 lg:max-w-md">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Search Products
                    </label>
                    <SearchBar
                        placeholder="Search for Product | SKU | Brand | Manufacturer"
                        onSearch={handleSearch}
                        value={searchText}
                    />
                </div>

                {/* Filters Section */}
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Filters
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        <Dropdown
                            name="availability"
                            value={filterAvailability}
                            options={[
                                { value: "IN_STOCK", label: "In Stock" },
                                { value: "OUT_OF_STOCK", label: "Out of Stock" },
                                { value: "LIMITED_STOCK", label: "Limited Stock" },
                                { value: "PREORDER", label: "Preorder" },
                                { value: "DISCONTINUED", label: "Discontinued" },
                            ]}
                            placeholder="Availability"
                            onChange={handleAvailabilityChange}
                        />
                        <Dropdown
                            name="brand"
                            value={filterBrand}
                            options={brands}
                            needSearch
                            placeholder="Brand"
                            onChange={handleBrandChange}
                        />
                        <Dropdown
                            name="top_offer"
                            value={filterTopOffer}
                            options={[
                                { value: '', label: 'All' },
                                { value: true, label: 'Top Offer: Yes' },
                                { value: false, label: 'Top Offer: No' },
                            ]}
                            placeholder="Top Offer"
                            onChange={(val) => { setFilterTopOffer(val); fetchData(buildQuery({ top_offer: val })); }}
                        />
                        <Dropdown
                            name="is_today_offer"
                            value={filterTodayOffer}
                            options={[
                                { value: '', label: 'All' },
                                { value: true, label: "Today's Offer: Yes" },
                                { value: false, label: "Today's Offer: No" },
                            ]}
                            placeholder="Today's Offer"
                            onChange={(val) => { setFilterTodayOffer(val); fetchData(buildQuery({ is_today_offer: val })); }}
                        />
                        <div className="flex items-end">
                            {(searchText.length !== 0 || filterAvailability.length !== 0 || filterTopOffer !== "" || filterTodayOffer !== "" || filterBrand !== "") && (
                                <button
                                    onClick={resetFilters}
                                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 hover:text-gray-800 transition-colors duration-200 h-10"
                                >
                                    <BiRefresh size={16} />
                                    Reset
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        onFilterChange={handleTableSort}
                        currentSort={currentSort}
                        currentSortDir={currentSortDir}
                        rows={data?.results?.map((item, index) => (
                            {
                                // id: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.id}>{item.id}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.id) }} /></span>,
                                name: <Link to={`/bazzar/products/${item.slug}/`}> <span className='flex flex-row gap-1 items-center cursor-pointer hover:underline hover:text-primary'><p className="w-full truncate max-w-[8rem]" title={item.aka_name || item.product_name}>{item.aka_name || item.product_name}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.aka_name || item.product_name) }} /></span></Link>,
                                image: <GalleryComponent openingComponent={item.images.length > 0 ? <img src={item.images[0]} className="rounded-sm aspect-square max-h-12" /> : <p>-</p>} className='rounded-full aspect-square max-w-28 border border-primary' images={item.images} />,
                                order: <div className="w-18">
                                    <Dropdown
                                        placeholder={item.order}
                                        value={item.order} onChange={(value) => handleOrderChange(item, value)} options={[
                                            { value: 0, label: "0" },
                                            { value: 1, label: "1" },
                                            { value: 2, label: "2" },
                                            { value: 3, label: "3" },
                                            { value: 4, label: "4" },
                                            { value: 5, label: "5" },
                                            { value: 6, label: "6" },
                                            { value: 7, label: "7" },
                                            { value: 8, label: "8" },
                                            { value: 9, label: "9" },
                                            { value: 10, label: "10" },
                                        ]} />
                                </div>,
                                category: <Link to={`/bazzar/categories/${item.category}/`}> <p>{item.category}</p></Link>,
                                website_url: <a className='text-blue-600 hover:underline' href={`https://bazaar.rashailagro.in/view/products/${item.slug}/`} target="_blank" rel="noreferrer"><Link2Icon /></a>,
                                is_today_offer: <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={item.is_today_offer}
                                        onChange={(e) => handleIsTodayOffer(item, e.target.checked)}
                                        className="sr-only peer"
                                    />
                                    <div className="w-11 h-6 bg-gray-300 peer-checked:bg-primary rounded-full transition-all duration-300" />
                                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all duration-300 peer-checked:translate-x-5" />
                                </label>,
                                top_offer: <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={item.order === 0 ? true : false}
                                        onChange={(e) => handleTopOffer(item, e.target.checked)}
                                        className="sr-only peer"
                                    />
                                    <div className="w-11 h-6 bg-gray-300 peer-checked:bg-primary rounded-full transition-all duration-300" />
                                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all duration-300 peer-checked:translate-x-5" />
                                </label>,
                                discount_percentage: <Link to={`/bazzar/products/${item.slug}/`}> <p className='text-slate-500'>{item.discount_percentage} %</p></Link>,
                                manufacture: <Link to={`/bazzar/manufacturers/${item.manufacture}/`}> <p>{item.manufacture}</p></Link>,
                                mrp: <Link to={`/bazzar/products/${item.slug}/`}> <p className='text-primary'>₹{item.mrp}</p></Link>,
                                price: <Link to={`/bazzar/products/${item.slug}/`}> <p className='text-yellow-400'>₹{item.price}</p></Link>,
                                available_stock: <Link to={`/bazzar/products/${item.slug}/`}> <p>{item.available_stock ?? '-'}</p></Link>,
                                sold_stock: <Link to={`/bazzar/products/${item.slug}/`}> <p>{item.sold_stock ?? '-'}</p></Link>,
                                shop: <Link to={`/bazzar/shops/${item.shop}/`}> <p>{item.shop}</p></Link>,
                                availability_status: <div className="w-32">
                                    <Dropdown
                                        placeholder={item.availability_status}
                                        value={item.availability_status} onChange={(value) => handleStockChange(item, value)} options={[
                                            { value: 'IN_STOCK', label: 'In Stock' },
                                            { value: 'OUT_OF_STOCK', label: 'Out of Stock' },
                                            { value: 'LIMITED_STOCK', label: 'Limited Stock' },
                                            { value: 'PREORDER', label: 'Preorder' },
                                            { value: 'DISCONTINUED', label: 'Discontinued' },
                                        ]} />
                                </div>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default Products;